import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { TaxLine } from 'store/invoices/types';
import { InvoiceUtils } from 'utils/InvoiceUtils';
import { InvoiceFieldValues } from 'views/invoices/types';

const useInvoiceTotals = (taxLines: TaxLine[]) => {
    const { values } = useFormikContext<InvoiceFieldValues>();

    return useMemo(
        () => InvoiceUtils.calculateTotals(taxLines, values.additionalCharges),
        [taxLines, values.additionalCharges]
    );
};

export default useInvoiceTotals;
